var map = {
	"./payment-offline/view/epic": 2512,
	"./reward-points/view/epic": 2515,
	"./stripe-terminal-payment/view/epic": 2520,
	"./take-shipment/view/epic": 2522
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2511;


//////////////////
// WEBPACK FOOTER
// ./src/extension ^\.\/.*\/view\/epic$
// module id = 2511
// module chunks = 0